import { TaskNew } from '../../plugins/api'

export default {
  namespaced: true,
  state: {
    listUsers: [],
    tasks: [],
    taskHistories: [],
  },
  mutations: {
    setListUsers(state, users) {
      state.listUsers = users
    },
    setTasks(state, tasks) {
      state.tasks = tasks
    },
    setTaskHistories(state, histories) {
      state.taskHistories = histories
    },
  },
  actions: {
    async createTaskNew({ dispatch }, taskData) {
      try {
        console.log('dispatch', dispatch)
        const task_new = await TaskNew.create({ ...taskData })
        console.log('task_new', task_new)
        return true
      } catch (error) {
        console.error('Tạo mới công việc thất bại!')
        console.error(error)
        return false
      }
    },
    async deleteTaskNew({ dispatch }, taskId) {
      try {
        console.log('dispatch', dispatch)
        console.log('taskId', taskId)
        const task_new = await TaskNew.remove(taskId)
        console.log('task_new', task_new)
        return true
      } catch (error) {
        console.error('Tạo mới công việc thất bại!')
        console.error(error)
        return false
      }
    },
    async findUsersExcludeRoles({ commit }, { page, limit, keyword }) {
      try {
        const user_exclu = await TaskNew.findUsersExcludeRoles({ page, limit, keyword })
        console.log('user_exclu', user_exclu)
        commit('setListUsers', user_exclu)
        return user_exclu
      } catch (error) {
        console.error('Lấy danh sách người giao việc thất bại!')
        console.error(error)
        return false
      }
    },
    async findTaskByFilter({ commit }, options) {
      try {
        console.log('commit', commit)
        console.log('filter', options)
        const tasks = await TaskNew.findTaskByFilter(options)
        console.log('TASKS', tasks.data)
        commit('setTasks', tasks.data)
        return tasks
      } catch (error) {
        console.error('Lấy danh sách công việc thất bại!')
        console.error(error)
        return []
      }
    },

    async fetchTaskHistory({ commit }, taskId) {
      try {
        const res = await TaskNew.findHistoryTask(taskId)
        commit('setTaskHistories', res)
        return res
      } catch (err) {
        console.error('Lỗi lấy lịch sử task:', err)
        return []
      }
    },
    async updateTask({ dispatch }, data) {
      try {
        console.log('dispatch', dispatch)
        const res = await TaskNew.updateTask(data)
        return res
      } catch (error) {
        console.error('Cập nhật công việc thất bại!')
        console.error(error)
        throw error
      }
    },
    async fetchTaskReport({ dispatch }, options) {
      try {
        console.log('dispatch', dispatch)
        console.log('filter', options)
        const tasks_report = await TaskNew.findTaskReport(options)
        return tasks_report
      } catch (error) {
        console.error('Lấy danh sách báo cáo công việc thất bại!')
        console.error(error)
        return []
      }
    },
    async findTaskByReceiver({ dispatch }, options) {
      try {
        console.log('dispatch', dispatch)
        console.log('filter', options)
        const tasks_report = await TaskNew.findTaskByReceiver(options)
        console.log('TASKSREPORT', tasks_report)
        return tasks_report
      } catch (error) {
        console.error('Lấy danh sách báo cáo công việc thất bại!')
        console.error(error)
        return []
      }
    },
  },
  getters: {
    listUsers: state => state.listUsers,
    tasks: state => state.tasks,
  },
}
